import Vue from 'vue';
import Router from 'vue-router';
import Hellor from '../components/HelloFromVux'
import CarPoint from '../components/carPosition'
import pickupStation from '../components/pickGiveStation/pickupStation'
import giveawayStation from '../components/pickGiveStation/giveawayStation'
import pickupAircraft from '../components/pickGiveAircraft/pickupAircraft'
import giveawayAircraft from '../components/pickGiveAircraft/giveawayAircraft'
import arriveAddress from '../components/pickGiveStation/arriveAddressB.vue'
import posi from '../components/common/posi.vue'
import address from '../components/common/address.vue'
import serachAircraft from '../components/pickGiveAircraft/serachAircraft.vue'
import serachAircraftList from '../components/pickGiveAircraft/serachAircraftList.vue'
import orderlist from '../components/order/list.vue'
import orderInfo from '../components/order/orderDetail.vue'

Vue.use(Router);
const getRootPath = window.document.location.pathname
export default new Router({
    //mode: 'history',
    base:'/shuttle2/',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            name: 'Hello',
            redirect: '/pickupStation',
            component: Hellor,
            children: [
                {path: '/pickupStation', component: pickupStation},
                {path: '/giveawayStation', component: giveawayStation},
                {path: '/pickupAircraft', component: pickupAircraft},
                {path: '/giveawayAircraft', component: giveawayAircraft},
            ]
        },
        {
            path: '/arriveAddressB',
            name: 'arriveAddress',
            component: arriveAddress,
        }, {
            path: '/address',
            name: 'cccc',
            component: address,
        }, {
            path: '/posi',
            name: '城市选择',
            component: posi,
        }, {
            path: '/serachAircraft',
            name: '查询班次',
            component: serachAircraft,
        }, {
            path: '/serachAircraftList',
            name: '班次列表',
            component: serachAircraftList,
        },  {
            path: '/orderlist',
            name: '订单列表',
            component: orderlist,
        }, {
            path: '/order/:id/:bizType',
            name: '订单详情',
            component: orderInfo,
        }, {
            path: '/carposition',
            name: '司机位置',
            component: CarPoint,
        },
        // {
        //     path: '/order/:id',
        //     name: '订单详情',
        //     component: orderInfo,
        // }

    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js